import { useState, useEffect } from 'react';

export function useSwipeDetection(ref, handlers) {
    const [direction, setDirection] = useState(null);
    const { current: node } = ref;

    useEffect(() => {
        let initialX = null;
        let initialY = null;

        function startTouch(e) {
            initialX = e.touches[0].clientX;
            initialY = e.touches[0].clientY;
        }

        function moveTouch(e) {
            if (initialX === null) {
                return;
            }

            if (initialY === null) {
                return;
            }

            const currentX = e.touches[0].clientX;
            const currentY = e.touches[0].clientY;

            const diffX = initialX - currentX;
            const diffY = initialY - currentY;

            if (Math.abs(diffX) > Math.abs(diffY)) {
                // sliding horizontally
                if (diffX > 5) {
                    // swiped left
                    setDirection('left');
                    if (handlers.left) {
                        handlers.left();
                    }
                } else {
                    // swiped right
                    setDirection('right');
                    if (handlers.right) {
                        handlers.right();
                    }
                }
            } else if (diffY > 5) {
                // swiped up
                setDirection('up');
                if (handlers.up) {
                    handlers.up();
                }
            }
            // sliding vertically
            else {
                // swiped down
                setDirection('down');
                if (handlers.down) {
                    handlers.down();
                }
            }

            initialX = null;
            initialY = null;
        }

        if (node) {
            node.removeEventListener('touchstart', startTouch);
            node.removeEventListener('touchmove', moveTouch);

            node.addEventListener('touchstart', startTouch, { passive: false });
            node.addEventListener('touchmove', moveTouch, { passive: false });
        } else {
            document.removeEventListener('touchstart', startTouch);
            document.removeEventListener('touchmove', moveTouch);

            document.addEventListener('touchstart', startTouch, { passive: false });
            document.addEventListener('touchmove', moveTouch, { passive: false });
        }

        return () => {
            if (node) {
                node.removeEventListener('touchstart', startTouch);
                node.removeEventListener('touchmove', moveTouch);
            } else {
                document.removeEventListener('touchstart', startTouch);
                document.removeEventListener('touchmove', moveTouch);
            }
        };
    }, [node, handlers]);

    return direction;
}
